// extracted by mini-css-extract-plugin
export default {"wrap":"MobileMenu_wrap__ubySE","link":"MobileMenu_link__Ze4te","icon":"MobileMenu_icon__rMCqr","selected":"MobileMenu_selected__hAHuj","bottom":"MobileMenu_bottom__U62Sv"};